import TopBar from './components/TopBar';
import Hero from './components/Hero';
import LatestEvidence from './components/LatestEvidence';
import CategoryIndex from './components/CategoryIndex';
import TopicWall from './components/TopicWall';
import Verification from './components/Verification';
import DossierReading from './components/DossierReading';
import EntryHub from './components/EntryHub';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <TopBar />
      <main>
        <Hero />
        <LatestEvidence />
        <CategoryIndex />
        <TopicWall />
        <Verification />
        <DossierReading />
        <EntryHub />
      </main>
      <Footer />
    </div>
  );
}